import React from "react";
import "./Header.scss";
import logo from "../../../assets/cdl_logo.webp";
import CustomizedMenus from "./MobileViewMenu";

const basePath = "https://cdlschool.com";
const menuItems = [
  {
    title: "Truck Driving Classes",
    links: [
      { path: `${basePath}/cdl-training`, label: "All Classes" },
      { path: `${basePath}/cdl-training/eldt-training`, label: "ELDT Training" },
      { path: `${basePath}/cdl-training/cdl-class-a-training`, label: "CDL Class A" },
      { path: `${basePath}/cdl-training/cdl-class-b-training`, label: "CDL Class B" },
      { path: `${basePath}/cdl-training/hazmat-endorsement`, label: "Hazmat Endorsement" },
      { path: `${basePath}/troops-into-transportation`, label: "Programs for Veterans" },
    ],
  },
  {
    title: "CDL FAQ",
    links: [
      { path: `${basePath}/cdl-faq`, label: "All CDL FAQ" },
      { path: `${basePath}/cdl-faq/why-become-truck-driver`, label: "Why Become a Truck Driver" },
      { path: `${basePath}/cdl-faq/how-to-become-a-truck-driver`, label: "How to Become a Truck Driver" },
      { path: `${basePath}/cdl-faq/cdl-career-opportunities`, label: "CDL Career Opportunities" },
      { path: `${basePath}/cdl-faq/financial-aid`, label: "Financing Your CDL Training" },
    ],
  },
  {
    title: "Career Services",
    links: [
      { path: `${basePath}/career-services/job-placement`, label: "Job Placement" },
      { path: `${basePath}/career-services/carrier-partners`, label: "Carrier Partners" },
    ],
  },
  {
    title: "About Us",
    links: [
      { path: `${basePath}/about`, label: "Why the CDL Schools" },
      { path: `${basePath}/about/careers`, label: "Join Our Team" },
      { path: `${basePath}/about/locations`, label: "Locations" },
      { path: `${basePath}/about/employer-solutions`, label: "Employer Solution" },
    ],
  },
];

const Header = () => {
  return (
    <header>
    <div className="header_container">
      <div className="header_logo">
        <img src={logo} className="logo" alt="CDL Logo" />
      </div>
      <div className="header_menu">
        {menuItems.map((item) => (
          <div className="menu_item" key={item.title}>
            <h4>{item.title}</h4>
            <div className="dialog">
              {item.links.map((link) => (
                <a href={link.path} key={link.path}>{link.label}</a>
              ))}
            </div>
          </div>
        ))}
        <a href={`${basePath}/students`}>Student Login</a>
      </div>
      <CustomizedMenus/>
    </div>
    </header>
  );
};

export default Header;